import { SxProps, Box, Theme, Stack, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ScaleLabeling } from '../../types/charts'
import { hasEnergyTotal } from '../../utils/energy'

export interface ChartSummaryProps {
  sx?: SxProps<Theme>
  main: string
  unit: string
  left?: string | JSX.Element
  right?: string
  total?: string
  steps?: ScaleLabeling
}

/**
 * Display a common title for a page.
 */
export const ChartSummary = (props: ChartSummaryProps): JSX.Element => {
  const { main, unit, left, right, total, steps } = props
  const theme = useTheme()
  const { t } = useTranslation()

  // Label of the energy total per bucket scale.
  const totalLabel = (): string => {
    switch (steps) {
      case 'day':
        return t('Daily total')
      case 'week':
        return t('Weekly total')
      case 'month':
        return t('Monthly total')
      case 'year':
        return t('Yearly total')
      default:
        return ''
    }
  }

  const TotalBox = !!total && hasEnergyTotal(steps) && (<Stack >
      <Box sx={{ fontSize: '2rem', color: theme.palette.chartText.main, fontWeight: 400 }}>
        {total}
        <Box component="span" sx={{ ml: 0.7, fontSize: '1rem', color: theme.palette.chartText.main, fontWeight: 400 }}>
          kWh
        </Box>
      </Box>
      <Box>
        {totalLabel()}
      </Box>
  </Stack>)

  return (
    <Box sx={{ ml: 4, ...props.sx }}>
      <Stack direction="row">
        <Box sx={{ width: right ? '60%' : '100%' }}>
          <Stack direction="column">
            <Box sx={{ fontSize: '2rem', color: theme.palette.chartText.main, fontWeight: 400 }}>
              {main}
              <Box component="span" sx={{ ml: 0.7, fontSize: '1rem', color: theme.palette.chartText.main, fontWeight: 400 }}>
                {unit}
              </Box>
            </Box>
            <Box>
              {left}
            </Box>
          </Stack>
        </Box>
        {TotalBox}
        {right && <Box sx={{ textAlign: 'right', display: 'flex', width: '40%', color: theme.palette.chartText.main, fontSize: '0.75rem', fontWeight: 400 }}>
          <Box sx={{ width: '100%', alignSelf: 'flex-end', textAlign: 'right' }}>{right}</Box>
        </Box>}
      </Stack>
    </Box>
  )
}
